import { render, staticRenderFns } from "./Lieqiliebiao.vue?vue&type=template&id=63d4aff6&scoped=true&"
import script from "./Lieqiliebiao.vue?vue&type=script&lang=js&"
export * from "./Lieqiliebiao.vue?vue&type=script&lang=js&"
import style0 from "./Lieqiliebiao.vue?vue&type=style&index=0&id=63d4aff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d4aff6",
  null
  
)

export default component.exports